module.exports = ":host .sticky {\n  position: sticky; }\n\n:host .header {\n  background-image: none;\n  position: sticky; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/main/content/documents/document-details/document-details.component.scss
// module id = ./src/app/main/content/documents/document-details/document-details.component.scss
// module chunks = main